import { ReactNode } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import classnames from 'classnames';

type ExpandableContentProps = {
  show: boolean;
  className?: string;
  children?: ReactNode;
};

const ExpandableContent = ({ show = true, children, className }: ExpandableContentProps) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className={classnames('overflow-hidden', className)}
          initial={{ height: 0 }}
          animate={{ height: 'auto' }}
          exit={{ height: 0, opacity: 0, visibility: 'hidden' }}
          transition={{ duration: 0.2 }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
export default ExpandableContent;
